import type { BlogPublicService, BlogService } from "@/shared/blog/blogService.contract";
import { httpBlogService } from "./blogService.http";
import { mockBlogService } from "./blogService.mock";
import { httpTopicsService } from "./topicsService.http";
import { mockTopicsService } from "./topicsService.mock";
import type { TopicsService } from "./topicsService.contract";
import { httpSuggestionsService } from "./suggestionsService.http";
import { mockSuggestionsService } from "./suggestionsService.mock";
import type { SuggestionsService } from "./suggestionsService.contract";
import { httpJobsService } from "./jobsService.http";
import { mockJobsService } from "./jobsService.mock";
import type { JobsService } from "./jobsService.contract";

/**
 * Fonte única do serviço de blog. Os consumidores (hooks/páginas) importam
 * apenas `blogService` — nunca `blogService.http`/`blogService.mock`
 * diretamente — e não sabem qual implementação está por trás.
 *
 * A escolha é por env, no mesmo espírito do `src/config/env.ts` (Zod sobre
 * `import.meta.env`), mas resolvida aqui — e não lá — porque este arquivo é
 * o único ponto desta feature autorizado a decidir isso, e o E1.4 não deveria
 * precisar tocar na config global só para isso. DEFAULT É `http`: o mock só
 * entra quando alguém pede explicitamente `VITE_BLOG_SERVICE=mock` no `.env`
 * (ver `.env.example`), para não vazar dado fake em nenhum ambiente real.
 */
const BLOG_SERVICE_ENV = import.meta.env.VITE_BLOG_SERVICE;
const useMock = BLOG_SERVICE_ENV === "mock";

export const blogService: BlogService & BlogPublicService = useMock
  ? mockBlogService
  : httpBlogService;

/** Banco de pautas (E4.4). Mesma escolha de env que `blogService`. */
export const topicsService: TopicsService = useMock
  ? mockTopicsService
  : httpTopicsService;

/** Fila de sugestões de atualização (E7.3). Mesma escolha de env que `blogService`. */
export const suggestionsService: SuggestionsService = useMock
  ? mockSuggestionsService
  : httpSuggestionsService;

/** Painel do CMO — jobs e resumos semanais (E7.4). Mesma escolha de env que `blogService`. */
export const jobsService: JobsService = useMock ? mockJobsService : httpJobsService;
